module.exports = __webpack_public_path__ + "img/Mask5.0f7430b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/Mask5.png
// module id = lgCm
// module chunks = 149